import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {SendGridWebhook} from "../api";

export class WebHookService extends RestService<SendGridWebhook> {
    constructor(url: string) {
        url ? super(url) : super(REST_API_END_POINTS.WEB_HOOKS)
    }


}
